<style scoped>
	.full-page-loading {
		width:100%;
		height:100%;
		position:absolute;
		top:0px;
		left:0px;
		text-align: center;
		padding-top: 200px;
	}

    .md-skin .nav-second-level li {
        width: 100%;
    }
</style>
<template>
    <div id="wrapper" :class="$route.matched.some(route => route.meta.hasSidebar) ? 'has-right-nav h-100' : ''">
    	<div class="full-page-loading" v-if="!loaded">
    		<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> <h2>Loading....</h2>
    	</div>

        <nav class="navbar-default navbar-static-side" role="navigation" v-if="loaded">
            <div class="sidebar-collapse" style="overflow: hidden">
                <ul class="nav metismenu" id="side-menu">
                    <router-link tag="li" :to="{name: 'home'}"><a><i class="fal fa-fw fa-home"></i> <span class="nav-label">Home</span></a></router-link>
                    <li v-if="$can('read financials')">
                        <a><i class="fal fa-fw fa-tachometer"></i> <span class="nav-label">Dashboards</span> <span class="fa arrow"></span></a>
                        <ul class="nav nav-second-level">
                          <router-link tag="li" :to="{name: 'dashboards.utilization'}"><a>Utilization</a></router-link>
                          <router-link tag="li" :to="{name: 'dashboards.financial'}"><a>Financial</a></router-link>
                          <router-link tag="li" :to="{name: 'dashboards.sales'}"><a>Sales</a></router-link>
                        </ul>
                    </li>

                    <router-link v-if="$can('read leads')" tag="li" :to="{name: 'leads.index'}"><a><i class="fal fa-fw fa-lightbulb"></i> <span class="nav-label">Leads</span></a></router-link>
                    <router-link v-if="$can('read opportunities')" tag="li" :to="{name: 'opportunities.index'}"><a><i class="fal fa-fw fa-lightbulb"></i> <span class="nav-label">Opportunities</span></a></router-link>
                    <router-link tag="li" :to="{name: 'signoffs.index'}"><a><i class="fal fa-fw fa-lightbulb"></i> <span class="nav-label">Sign-Offs</span></a></router-link>
                    <router-link tag="li" :to="{name: 'clients.index'}"><a><i class="fal fa-fw fa-building"></i> <span class="nav-label">Clients</span></a></router-link>
                    <router-link v-if="$can('read stacks')" tag="li" :to="{name: 'stacks.index'}"><a><i class="fal fa-fw fa-lightbulb"></i> <span class="nav-label">Stacks</span></a></router-link>
                    <router-link tag="li" :to="{name: 'retainers.index'}"><a><i class="fal fa-fw fa-sync"></i> <span class="nav-label">Retainers</span></a></router-link>

                    <li>
                        <a><i class="fal fa-fw fa-coins"></i> <span class="nav-label">Financial</span> <span class="fa arrow"></span></a>
                        <ul class="nav nav-second-level">
                          <router-link v-if="$can('read invoices')" tag="li" :to="{name: 'invoices.index', query: { type: '1' }}">
                            <a><span class="nav-label">Invoices</span></a>
                          </router-link>
                          <router-link tag="li" :to="{name: 'budgets.index'}">
                            <a><span class="nav-label">T&M</span></a>
                          </router-link>
                          <router-link v-if="$isA('admin')" tag="li" :to="{name: 'financial-targets.index'}">
                            <a><span class="nav-label">Financial Targets</span></a>
                          </router-link>
                          <router-link v-if="$can('read financials')" tag="li" :to="{name: 'forecast.index'}">
                            <a class="nav-label">Cashflow Forecast</a>
                          </router-link>
                        </ul>
                    </li>



                    <!-- <router-link tag="li" :to="{name: 'clients.index'}"><a><i class="material-icons business"></i> <span class="nav-label">Clients</span></a></router-link> -->
                    <li>
                        <a><i class="fal fa-fw fa-ticket"></i> <span class="nav-label">Support</span> <span class="fa arrow"></span></a>
                        <ul class="nav nav-second-level">
                            <router-link tag="li" :to="{name: 'dashboards.support'}"><a>Dashboard</a></router-link>
                            <router-link tag="li" :to="{name: 'slas.index'}"> <a><span class="nav-label">SLAs</span></a></router-link>
                            <router-link tag="li" :to="{name: 'invoices.uninvoiced', query: { type: '2' }}"><a>Uninvoiced Work</a></router-link>
                            <router-link tag="li" :to="{name: 'support.project-dependencies'}"><a>Project Dependencies</a></router-link>
                        </ul>
                    </li>
                    <!-- <router-link v-if="this.$user.isAdmin" tag="li" :to="{name: 'sprint-reviews.index'}"><a><i class="fa fa-check-square-o"></i> <span class="nav-label">Sprint Reviews</span></a></router-link> -->

                    <li>
                        <a><i class="fal fa-fw fa-folder"></i> <span class="nav-label">Projects</span> <span class="fa arrow"></span></a>
                        <ul class="nav nav-second-level">
                            <router-link tag="li" :to="{name: 'projects.index'}">
                                <a><span class="nav-label">Projects</span></a>
                            </router-link>
                            <router-link tag="li" :to="{name: 'projects.planner.index'}">
                                <a><span class="nav-label">Project Planner</span></a>
                            </router-link>

                            <router-link tag="li" :to="{name: 'projects.project-statuses'}">
                                <a><span class="nav-label">Project Statuses</span></a>
                            </router-link>
                            <router-link tag="li" :to="{name: 'warranties.index'}">
                                <a><span class="nav-label">Warranties</span></a>
                            </router-link>
                            <router-link
                              v-if="$can('read project calculations')"
                              tag="li"
                              class="nav-item"
                              :to="{name: 'project-calculations.index'}"
                            >
                              <a class="nav-link">Project Calculations</a>
                            </router-link>
                        </ul>
                    </li>

                    <li>
                        <a><i class="fal fa-fw fa-code"></i> <span class="nav-label">Dev Ops</span> <span class="fa arrow"></span></a>
                        <ul class="nav nav-second-level">
                          <router-link v-if="isAdmin" tag="li" :to="{name: 'clusters.index'}">
                              <a><span class="nav-label">Clusters</span></a>
                          </router-link>
                          <router-link tag="li" :to="{name: 'applications.index'}">
                              <a><i class="fal fa-fw fa-code"></i> <span class="nav-label">Applications</span></a>
                          </router-link>
                        </ul>
                    </li>

                    <router-link tag="li" :to="{name: 'users.index'}">
                        <a>
                            <i class="fal fa-fw fa-users"></i> <span class="nav-label">Users</span>
                        </a>
                    </router-link>

                    <router-link tag="li" :to="{name: 'settings.index'}">
                        <a>
                            <i class="fal fa-fw fa-cog"></i> <span class="nav-label">Settings</span>
                        </a>
                    </router-link>

                    <router-link tag="li" :to="{name: 'ai.index'}">
                        <a>
                            <i class="fal fa-fw fa-robot"></i> <span class="nav-label">AI Chat</span>
                        </a>
                    </router-link>
                </ul>
            </div>
        </nav>

        <div id="page-wrapper" class="gray-bg" v-bind:class="[$route.matched.some(route => route.meta.hideNav) ? 'no-navbar' : '', $route.matched.some(route => route.meta.hideFooter) ? 'no-footer' : '', $route.matched.some(route => route.meta.flex) ? 'flex' : '']" v-if="loaded">
            <div class="row border-bottom">
                <nav role="navigation" class="navbar navbar-fixed-top white-bg" style="margin-bottom: 0px;">
                    <div class="navbar-header">
                        <div class="left">
                            <img src="~assets/img/navbar-logo.png" class="hidden-xs" alt="Codium Logo" />
                            <a @click="toggleMenu" class="navbar-minimalize btn">
                                <i class="fa fa-bars"></i>
                            </a>
                        </div>
                    </div>

                    <search></search>

                    <!-- <div class="carbon-search">

                    </div> -->

                    <save-status v-if="showSaveStatus"></save-status>

                    <ul class="nav navbar-top-links navbar-right">
                        <li>
                            <a href="#" class="profile">
                                {{ authorized.name }} <img :src="getAvatar(authorized.id)" :alt="authorized.name" />
                            </a>
                        </li>
                        <li>
                            <silicon></silicon>
                        </li>
                        <router-link tag="li" :to="{name: 'auth.logout'}">
                            <a href="#">
                                <i class="fal fa-sign-out"></i>
                            </a>
                        </router-link>
                    </ul>
                </nav>
            </div>

            <template v-if="notLoading">
                <router-view></router-view>
            </template>
            <template v-if="loading">&nbsp;</template>
        </div>

        <chat-window v-if="loaded" />
    </div>


</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import $ from 'jquery'
    import 'bootstrap'
    import 'bootstrap-drawer/js/drawer'
    import Silicon from '../components/silicon/silicon'
    import SaveStatus from '../components/misc/SaveStatus'
    import Search from '../components/search'
    import ChatWindow from '../components/ai/ChatWindow'
    import {user} from 'mixins'
    import '@/assets/css/plugins/c3/c3.min.css'
    import '@/assets/css/animate.css'
    import old from '@/assets/sass/old.lazy.scss'

    export default {
        mixins: [user],
        data: function () {
            return {
                pageClass: '',
                loaded: true,
                //user: {},
                search: "",
                openChat: false
            }
        },

        components: {
            Silicon,
            SaveStatus,
            Search,
            ChatWindow
        },

        beforeDestroy () {
          old.unuse()
        },

        beforeRouteUpdate (to, from, next) {
            //Handle dynamic body classes from route params

            if (to.meta.fullPageModal) {
                document.body.classList.add('full-page-model-shown')
            }

            next()
        },

        computed: {
            ...mapState('settings/app', ['loading']),
            ...mapState('user', ['authorized']),

            notLoading () {
                return !this.loading
            },

            showSaveStatus () {
                if (this.$route.name == "projects.stage2.userstories" || this.$route.name == "projects.stage1.userstories" || this.$route.name == "opportunities.overview" || this.$route.name == "opportunities.costing") {
                    return true
                }

                return false
            }
        },

        created: function() {
            old.use()

            var that = this;

            $(function() {
                that.fix_height();
            })

            // Fixed Sidebar
            $(window).bind("load", function () {
                if ($("body").hasClass('fixed-sidebar')) {
                    $('.sidebar-collapse').slimScroll({
                        height: '100%',
                        railOpacity: 0.9
                    });
                }
            });

            // Move right sidebar top after scroll
            $(window).scroll(function () {
                if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
                    $('#right-sidebar').addClass('sidebar-top');
                } else {
                    $('#right-sidebar').removeClass('sidebar-top');
                }
            });

            $(window).bind("load resize scroll", function () {
                if (!$("body").hasClass('body-small')) {
                    that.fix_height();
                }
            });


        	// The app has just been initialized, check if we can get the user data with an already existing token
                // var token = localStorage.getItem('token')
                // if (token !== null && token !== 'undefined') {
                //     var that = this
                //     return client({ path: '/users/me' }).then(
                //         function (response) {
                //       // User has successfully logged in using the token from storage
                //       //that.setLogin(response.entity.user)
                //       that.$bus.$emit('userHasLoggedIn', response.entity.user);

                //       // broadcast an event telling our children that the data is ready and views can be rendered
                //       that.$bus.$emit('data-loaded')

                //       that.user = response.entity.user;
                //       that.loaded = true;


                //   },
                //   function (response) {
                //       // Login with our token failed, do some cleanup and redirect if we're on an authenticated route

                //   })
                // } else {
                //     this.loaded = true
                // }

            setTimeout(function() {
              that.fix_height()
            }, 500)

            document.addEventListener('window.onunload', function() {
            	alert('sdf');
            	that.$bus.$emit('window-closed');
            });
        },
        mounted: function() {

            // Load the menu function MetsiMenu
            $('#side-menu').metisMenu();



        },
        methods: {
          toggleMenu () {
            $("body").toggleClass("mini-navbar");

            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                // Hide menu in order to smoothly turn on when maximize menu
                $('#side-menu').hide();
                // For smoothly turn on menu
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(400);
                    }, 200);
            } else if ($('body').hasClass('fixed-sidebar')) {
                $('#side-menu').hide();
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(400);
                    }, 100);
            } else {
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
            }

            this.$bus.$emit('menu-toggled')
          },
        	minimalizeNav: function() {
        		$("body").toggleClass("mini-navbar");
        	},
        	getAvatar: function(id) {
        		return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
        	},

            fix_height () {
                // var heightWithoutNavbar = $("body > #wrapper").height() - 61;
                // $(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

                // var navbarheight = $('nav.navbar-default').height();
                // //var wrapperHeight = $('#page-wrapper').height();

                // // if (navbarheight > wrapperHeight) {
                // //     $('#page-wrapper').css("min-height", navbarheight + "px");
                // // }

                // // if (navbarheight < wrapperHeight) {
                // //     $('#page-wrapper').css("min-height", $(window).height() + "px");
                // // }

                // if ($('body').hasClass('fixed-nav')) {
                //     if (navbarheight > wrapperHeight) {
                //         //$('#page-wrapper').css("min-height", navbarheight + "px");
                //     } else {
                //         //$('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
                //     }
                // }
            }
        }
    }
</script>
